import React, { Component } from 'react';
import { withStyles } from '@mui/styles';
import {
  Avatar,
  IconButton,
  InputBase,
  Alert,
  Snackbar,
  AlertTitle,
  Divider,
  Typography,
  Box,
} from '@mui/material';
import {
  Mail,
  Comment as PostIcon,
  Event as TaskIcon,
  Beenhere,
  Reply,
  PersonOutlined,
  SendOutlined,
} from '@mui/icons-material';
import PrimaryButton from 'components/Buttons/PrimaryButton';
import SimpleDialog from 'components/SimpleDialog';
import classNames from 'classnames';
import moment from 'moment';
import { getChitChatTypeKey } from 'common/chitChatTypes';
import { saveChitChatComment, fetchChitChat } from 'actions/chitchat';
import { connect } from 'react-redux';
import { Fade } from '@mui/material';
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';

const styles = theme => ({
  thread: {
    display: 'flex',
    flexDirection: 'column',
    marginTop: 20,
    border: `1px solid ${theme.palette.background.border}`,
    borderRadius: 10,
    background: theme.palette.background.paper,
    padding: '10px 25px',
  },
  top: {
    display: 'flex',
  },
  message: {
    display: 'flex',
    flexDirection: 'row',
    paddingBottom: 24,
  },
  messageIcon: {
    alignItems: 'center',
    marginTop: 2,
    marginRight: 10,
  },
  postAvatar: {
    color: theme.palette.common.red,
    backgroundColor: '#fff !important',
    border: `2px solid ${theme.palette.common.red}`,
    width: '30px !important',
    height: '30px !important',
  },
  postIcon: {
    color: theme.palette.common.red,
    fontSize: '18px !important',
  },
  replyAvatar: {
    color: theme.palette.common.bluegrey,
    backgroundColor: '#fff !important',
    border: `2px solid ${theme.palette.common.bluegrey}`,
    width: '30px !important',
    height: '30px !important',
  },
  replyIcon: {
    color: theme.palette.common.bluegrey,
    fontSize: '18px !important',
  },
  messageMainSection: {
    display: 'flex',
    flexDirection: 'column',
    flex: '1 1 auto',
    margin: '0 8px 8px 0',
    fontSize: 14,
    maxWidth: '92%',
    overflowX: 'auto',
    '&::-webkit-scrollbar': {
      display: 'none',
    },
  },
  messageSender: {
    color: theme.palette.light.purple1,
  },
  messageContent: {
    whiteSpace: 'initial',
    overflowWrap: 'break-word',
  },
  message1: {
    margin: '4px 0',
  },
  messageTime: {
    color: theme.palette.text.secondary,
    minWidth: 108,
    fontSize: 14,
    textAlign: 'right',
  },
  messageDropDown: {
    paddingLeft: 16,
  },
  magenta: {
    backgroundColor: theme.palette.common.magenta,
  },
  bluegrey: {
    backgroundColor: theme.palette.common.bluegrey,
  },
  red: {
    backgroundColor: theme.palette.common.red,
  },
  blue: {
    backgroundColor: theme.palette.blue.blue3,
  },
  hr: {
    margin: '4px 0',
    borderTop: '1px solid #F4C1CC',
  },
  commentSection: {
    display: 'flex',
    flexDirection: 'column',
    margin: '8px 60px 0',
    marginRight: 0,
  },
  comment: {
    display: 'flex',
    padding: 8,
    backgroundImage: 'linear-gradient(to bottom, #F9FAFB, #FEFEFE)',
    border: '1px solid #EBA1B0',
    borderRadius: 10,
  },
  inlineReplyWrapper: {
    display: 'flex',
    flex: 1,
    justifyContent: 'space-between',
    borderTop: `1px solid ${theme.palette.light.darkgrey}`,
    borderBottom: '1px solid #EBA1B0',
    paddingTop: 10,
    paddingBottom: 20,
  },
  inlineReply: {
    display: 'flex',
    flex: 1,
    justifyContent: 'space-between',
    border: `1px solid ${theme.palette.light.darkgrey}`,
    borderRadius: 10,
    backgroundColor: theme.palette.background.paper,
    minHeight: '70px !important',
    marginRight: 12,
  },
  replyField: {
    flex: '1 1 auto',
    padding: '6px 12px',
    maxWidth: '91%',
    '& .fr-view': {
      whiteSpace: 'normal',
    },
    '& .fr-wrapper.show-placeholder .fr-placeholder': {
      marginTop: '14px !important',
    },
  },
  replyInput: {
    width: '100%',
  },
  buttonContainer: {
    backgroundColor: theme.palette.background.paper,
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
  },
  sendButton: {
    backgroundColor: '#C1C7DB !important',
    borderRadius: '10px !important',
    textTransform: 'capitalize !important',
    fontSize: '14px !important',
    fontWeight: 'bold !important',
  },
  cancelButton: {
    borderRadius: '10px !important',
    textTransform: 'capitalize !important',
    color: '#C1C7DB !important',
    fontWeight: 'bold !important',
  },
  replyPrompt: {
    display: 'flex',
    flex: 1,
    cursor: 'pointer',
    alignItems: 'center',
    margin: '-30px 0 0 0',
    color: theme.palette.blue.blue3,
    width: 40,
    marginLeft: 'auto',
  },
  viewHidePrompt: {
    display: 'flex',
    flex: 1,
    cursor: 'pointer',
    alignItems: 'center',
    margin: '-30px 0 0 0',
    color: theme.palette.blue.blue3,
    width: 70,
    marginLeft: 'auto',
  },
  replyBorderLeft: {
    borderLeft: "3px solid #e07a87",
    paddingLeft: "12px",
  },
  replyBorderRight: {
    borderRight: "3px solid #e07a87",
    paddingRight: "12px",
  },
  dividerContainer: {
    padding: "8px 0 14px 0",
  },

  iconButton: {
    display: "flex",
    alignItems: "center",
    gap: 4,
    padding: "6px 10px",
    borderRadius: 8,
    color: "#5a749e !important", // applies to BOTH icon + text
    fontSize: '14px !important',
  },
  replyIconChildComment: {
    fontSize: '14px !important',
    color: "inherit", // inherit from parent (important ✅)
  },
});

class Thread extends Component {

  state = {
    isReplying: false,
    reply: {},
    errorMessage: false,
    errorMessageText: '',
  };

  errorDialog = React.createRef();

  getAvatar = chitChatType => {
    const { classes } = this.props;

    const icons = {
      'post': <PostIcon />,
      'email': <Mail />,
      'systemGeneratedAction': <Beenhere />,
      'userCreatedAction': <Beenhere />,
      'task': <TaskIcon />,
    };

    const colors = {
      'post': 'magenta',
      'email': 'bluegrey',
      'systemGeneratedAction': 'red',
      'userCreatedAction': 'red',
      'task': 'blue',
    };

    const color = colors[chitChatType] || 'magenta';
    const icon = icons[chitChatType] || null;

    return (
      <div className={classes.messageIcon}>
        <Avatar className={classNames(classes.icon, classes[color])}>
          {icon}
        </Avatar>
      </div>
    );
  };

  getSubjectLine = chitChatType => {
    const { classes, thread: { baseMessage } } = this.props;

    const subjectLines = {
      'post': baseMessage.from,
      'email': baseMessage.from + ' | Email | ' + baseMessage.subject,
      'systemGeneratedAction': 'System Generated Action',
      'userCreatedAction': baseMessage.from + ' | Action | ' + baseMessage.subject,
      'task': baseMessage.from + ' | Task Completed | ' + baseMessage.subject,
    };

    return <div className={classes.messageSender}>{subjectLines[chitChatType] || baseMessage.from}</div>;
  };

  onReply = () => {
    this.setState({ isReplying: true });
  };

  onCancelReply = () => {
    this.setState({ isReplying: false, reply: {} });
  };

  onSendComment = () => {
    const { reply } = this.state;
    const { thread, saveChitChatComment, eventLinkId } = this.props;

    if (!!reply.message) {
      const comment = {
        subject: 'Reply',
        content: reply.message,
        chitChatThreadId: thread.id,
        time: moment().format(),
      };

      saveChitChatComment(thread.relationshipId, comment, eventLinkId).then(response => {
        if (response && response.status !== 200) {
          this.setState({ errorMessage: true, errorMessageText: response.status + ' ' + (response.title || 'Something went wrong. Please try again.') });

          return;
        }
        this.setState({ isReplying: false, reply: {} });
        sessionStorage.setItem('overviewSelectedTab', '2');
        this.props.onCommentSent();
      }).catch(() => {
        this.setState({ errorMessage: true, errorMessageText: 'Something went wrong. Please try again.' });
        this.errorDialog.current.open('Something went wrong. Please try again.');
      });

    } else {
      this.setState({ errorMessage: true, errorMessageText: 'Please include a message.' });
      this.errorDialog.current.open('Please include a message.');
    }
  };

  handleChange = event => {
    const { target: { value, name } } = event;
    const reply = {
      ...this.state.reply,
      [name]: value,
    };

    this.setState({ reply });
  };

  render() {
    const { classes, thread } = this.props;
    const { isReplying, reply } = this.state;
    const message = thread.baseMessage;
    const chitChatType = getChitChatTypeKey(thread.chitChatType);

    moment.locale('en', {
      calendar: {
        lastDay: 'LT, [Yesterday]',
        sameDay: 'LT, [Today]',
        lastWeek: 'llll',
        sameElse: 'llll',
      },
    });

    return (
      <div className={classes.thread}>
        <div className={classes.top}>
          <div className={classes.messageIcon}>
            <Avatar className={classes.postAvatar}>
              <PersonOutlined className={classes.postIcon} />
            </Avatar>
          </div>
          <div className={classes.messageMainSection}>
            {this.getSubjectLine(chitChatType)}
            {message && <>
              <div className={classes.messageContent}>
                <p dangerouslySetInnerHTML={{ __html: message.content }}></p>
              </div>
            </>
            }
          </div>
          <div>
            <div className={classes.messageTime}>
              {message.time && moment(message.time).format("MMMM DD YYYY hh:mm A")}
            </div>
            {!isReplying &&
              <div
                className={classes.replyPrompt}
                onClick={this.onReply}
                style={{ marginTop: 3, marginRight: 25 }}
              >
                <IconButton
                  aria-label="Reply"
                  disableRipple
                  className={classes.iconButton}
                >
                  <Reply className={classes.replyIconChildComment} />
                  <span style={{ fontSize: 11 }}>Reply</span>
                </IconButton>
              </div>}

            {thread.comments.length > 0 &&
              <div className={classes.viewHidePrompt} style={{ marginTop: 2, marginRight: 35 }} onClick={this.props.onShowComments(thread)}>
                {!thread.showComments &&
                  <IconButton
                    aria-label="ViewComments"
                    disableRipple
                    className={classes.iconButton}
                  >
                    <KeyboardArrowUpIcon className={classes.replyIconChildComment} />
                    <span style={{ fontSize: 11 }}>{`View ${thread.comments.length} comments`}</span>
                  </IconButton>}
                {thread.showComments && <IconButton
                  aria-label="HideComments"
                  disableRipple
                  className={classes.iconButton}
                >
                  <KeyboardArrowDownIcon className={classes.replyIconChildComment} />
                  <span style={{ fontSize: 11 }}>{`Hide ${thread.comments.length} comments`}</span>
                </IconButton>}
              </div>
            }
          </div>
        </div>

        {isReplying &&
          <Fade in={isReplying}>
            <div className={classes.commentSection}>
              <div className={classes.inlineReplyWrapper}>
                <div className={classes.messageIcon}>
                  <Avatar className={classes.replyAvatar}>
                    <PersonOutlined className={classes.replyIcon} />
                  </Avatar>
                </div>
                <div className={classes.inlineReply}>
                  <div className={classes.replyField}>
                    <InputBase
                      name="message"
                      value={reply.message}
                      onChange={this.handleChange}
                      className={classes.replyInput}
                      placeholder="Write a reply..."
                      autoFocus
                    />
                  </div>

                </div>
                <div className={classes.buttonContainer}>
                  <PrimaryButton
                    variant="contained"
                    onClick={this.onSendComment}
                    className={classes.sendButton}
                    startIcon={<SendOutlined sx={{ fontSize: '16px', transform: 'rotate(-45deg)' }} />}
                    size='small'
                  >
                    Send
                  </PrimaryButton>

                  <PrimaryButton
                    variant="outlined"
                    aria-label="Cancel"
                    onClick={this.onCancelReply}
                    className={classes.cancelButton}
                    size='small'
                  >
                    Cancel
                  </PrimaryButton>
                </div>
              </div>
            </div>
          </Fade>
        }

        <div className={classes.commentSection}>
          {thread.comments.length > 0 && thread.showComments && (
            <div className={classes.dividerContainer}>
              <Divider variant="middle" sx={{
                "&::before, &::after": {
                  borderColor: '#EBA1B0',
                },
                marginLeft: '0',
                marginRight: '0',
              }}>
                <Box sx={{
                  borderRadius: '10px',
                  color: "red",
                  backgroundColor: '#FCF0F2',
                  padding: '0 10px',
                }}>
                  <Typography sx={{
                    fontSize: '12px',
                    textTransform: 'uppercase',
                  }}> {thread.comments.length} Replies</Typography>
                </Box>
              </Divider>
            </div>
          )}
          {thread.comments.length > 0 &&
            thread.showComments &&
            thread.comments.map((comment, index) => {

              const isRightAligned =
                comment.from === thread.baseMessage.from;

              return (
                <div
                  key={comment.id}
                  style={{
                    display: "flex",
                    width: "100%",
                    justifyContent: isRightAligned
                      ? "flex-end"
                      : "flex-start",
                  }}
                >
                  <div
                    className={
                      isRightAligned
                        ? classes.replyBorderRight
                        : classes.replyBorderLeft
                    }
                    style={{
                      width: "90%",
                      marginLeft: isRightAligned ? "10%" : "0",
                      marginRight: isRightAligned ? "0" : "10%",
                      marginBottom:
                        index !== thread.comments.length - 1
                          ? "10px"
                          : "0px",
                    }}
                  >
                    <div
                      className={classes.comment}
                      style={{
                        display: "flex",
                        alignItems: "flex-start",
                        justifyContent: "space-between",

                        backgroundColor: isRightAligned
                          ? "#DCF8C6"
                          : "#F1F1F1",
                        borderRadius: "10px",
                        padding: "12px 16px",
                      }}
                    >
                      <div
                        style={{
                          display: "flex",
                          alignItems: "flex-start",
                        }}
                      >
                        <div className={classes.messageIcon}>
                          <Avatar className={classes.replyAvatar}>
                            <PersonOutlined className={classes.replyIcon} />
                          </Avatar>
                        </div>

                        <div className={classes.messageMainSection}>
                          <div className={classes.messageSender}>
                            {comment.from}
                          </div>

                          <div className={classes.messageContent}>
                            <p
                              className={classes.message1}
                              dangerouslySetInnerHTML={{
                                __html: comment.content,
                              }}
                            />
                          </div>
                        </div>
                      </div>

                      <div className={classes.messageTime}>
                        {comment.time && moment(comment.time).format("MMMM DD YYYY hh:mm A")}
                      </div>
                    </div>
                  </div>
                </div>
              );
            })}
        </div>

        <SimpleDialog onlyOkayButton={true} innerRef={this.errorDialog} />

        <Snackbar open={this.state.errorMessage} autoHideDuration={6000} onClose={() => this.setState({ errorMessage: false })}
          anchorOrigin={{ vertical: 'top', horizontal: 'center' }}>
          <Alert severity="error">
            <AlertTitle>Error</AlertTitle>
            {this.state.errorMessageText}
          </Alert>
        </Snackbar>
      </div>
    );
  }
}
const mapStateToProps = state => ({
  eventLinkId: state.caterease.catereaseCP,
});

const mapDispatchToProps = {
  saveChitChatComment,
  fetchChitChat,

};

export default withStyles(styles)(connect(mapStateToProps, mapDispatchToProps)(Thread));
